module.exports = __webpack_public_path__ + "img/SZPX.9df94bcd.png";